module.exports = __webpack_public_path__ + "static/testimonial-3-f786492de9b0f3edf1c0dd1701ebfc17.png";